<template>
  <div class="header">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="container">
        <img src="../assets/image/logo.png" alt="logo" class="logo" @click="handleClick('home')">
        <div class="top-nav-right u-flex u-align-center">
          <div class="cl_FFF">服务热线：{{ phone }}</div>
          <div class="cl_FFF" style="cursor: pointer;" @click="handleClick('about')">关于我们</div>
          <div class="cl_FFF" style="cursor: pointer;" @click="handleClick('contact')">联系我们</div>
        </div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <div class="main-nav u-flex-col u-col-center u-rela">
      <img src="../assets/image/logo2.png" alt="nav" class="main-logo">
      <img src="../assets/image/title.png" alt="nav" class="main-title">
      <div class="search-box u-flex u-align-center u-m-t-40">
          <input v-model="keyword" type="text" placeholder="请输入关键词搜索" class="search-input">
          <button class="search-btn" @click="handleSearch">搜索</button>
          <button class="login-btn" @click="searchVisible = true"><i class="el-icon-search"></i> 报告查询</button>
      </div>
      <div class="u-font-14 u-abso u-b-25 fw_600" style="color: rgba(255, 255, 255, 0.4);">科学·专业·权威·客观·公正</div>
    </div>
    <!-- 主导航栏 -->
    <div class="main-nav-bar">
      <div class="container">
        <div class="nav-items">
          <div class="nav-item" :class="{ active: currentNav === 'evaluation' }" @click="handleNavClick('evaluation')">
            <img v-if="currentNav === 'evaluation'" src="../assets/image/icon11.png" alt="科技成果评价">
            <img v-else src="../assets/image/icon1.png" alt="科技成果评价">
            <span>科技成果评价</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'noveltySearch' }" @click="handleNavClick('noveltySearch')">
            <img v-if="currentNav === 'noveltySearch'" src="../assets/image/icon22.png" alt="科技查新">
            <img v-else src="../assets/image/icon2.png" alt="科技查新">
            <span>科技查新</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'register' }" @click="handleNavClick('register')">
            <img v-if="currentNav === 'register'" src="../assets/image/icon33.png" alt="科技成果登记">
            <img v-else src="../assets/image/icon3.png" alt="科技成果登记">
            <span>科技成果登记</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'award' }" @click="handleNavClick('award')">
            <img v-if="currentNav === 'award'" src="../assets/image/icon44.png" alt="科技奖励">
            <img v-else src="../assets/image/icon4.png" alt="科技奖励">
            <span>科技奖励</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'expert' }" @click="handleNavClick('expert')">
            <img v-if="currentNav === 'expert'" src="../assets/image/icon55.png" alt="专家智库">
            <img v-else src="../assets/image/icon5.png" alt="专家智库">
            <span>专家智库</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'case' }" @click="handleNavClick('case')">
            <img v-if="currentNav === 'case'" src="../assets/image/icon66.png" alt="案例展示">
            <img v-else src="../assets/image/icon6.png" alt="案例展示">
            <span>案例展示</span>
          </div>
          <div class="nav-item" :class="{ active: currentNav === 'about' }" @click="handleNavClick('about')">
            <img v-if="currentNav === 'about'" src="../assets/image/icon77.png" alt="关于我们">
            <img v-else src="../assets/image/icon7.png" alt="关于我们">
            <span>关于我们</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 报告查询 -->
    <el-dialog title="评价报告查询" :visible.sync="searchVisible" center :width="dialogWidth">
      <div class="search-form u-m-b-30">
          <div class="u-font-16 cl_333">报告编号：</div>
          <input v-model="number" type="text" class="search-input2">
          <button class="search-btn" style="background-color: #1B5AFF;" @click="handleSearch2" :loading="loading">查询</button>
      </div>
      <div class="table-container">
        <el-table :data="gridData" stripe lazy :loading="loading" :max-height="tableMaxHeight">
          <el-table-column property="number" label="报告编号" align="center"></el-table-column>
          <el-table-column property="date" label="评价日期" align="center"></el-table-column>
          <el-table-column property="name" label="成果名称" align="center"></el-table-column>
          <el-table-column property="completion_unit" label="完成单位" align="center"></el-table-column>
          <el-table-column property="entrust_unit" label="委托评价单位" align="center"></el-table-column>
          <el-table-column property="institution" label="评价机构" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDetailClick(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 报告详情 -->
    <el-dialog title="报告详情" :visible.sync="detailsVisible" center :width="dialogWidth">
       <div class="report-details">
        <div class="report-info">
          <div class="info-row">
            <span class="info-label">报告编号：</span>
            <span class="info-value">{{ info.number }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">评价日期：</span>
            <span class="info-value">{{ info.date }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">成果名称：</span>
            <span class="info-value">{{ info.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">完成单位：</span>
            <span class="info-value">{{ info.completion_unit }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">委托单位：</span>
            <span class="info-value">{{ info.entrust_unit }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">评价机构：</span>
            <span class="info-value">{{ info.institution }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">成果描述：</span>
            <span class="info-value">{{ info.description }}</span>
          </div>
        </div>
        <div class="report-certificate">
          <img :src="httphosts + info.image" alt="科学技术成果评价证书">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { contactInfoConfig, evaluationReportList, evaluationReportDetail } from '@/api/index.js'
import { httphosts } from '@/utils/global'

export default {
  name: 'Header',
  data() {
    return {
      httphosts: httphosts,
      keyword: '',
      currentNav: 'evaluation', // 默认选中科技成果评价
      searchVisible: false,
      mobileMenuOpen: false, // 移动端菜单状态
      // 评价报告列表
      gridData: [],
      number: '',
      detailsVisible: false,
      phone: '',
      code: '',
      page: 1,
      limit: 12,
      records: 0,
      id: '',
      info: {},
      loading: false,
      screenWidth: window.innerWidth
    }
  },
  computed: {
    dialogWidth() {
      if (this.screenWidth < 768) {
        return '90%';
      } else if (this.screenWidth < 1200) {
        return '70%';
      } else {
        return '70%';
      }
    },
    tableMaxHeight() {
      return window.innerHeight * 0.6;
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },
  created () {
    this.updateCurrentNav()
  },
  watch: {
    $route: {
      handler() {
        this.updateCurrentNav()
      },
      immediate: true
    }
  },
  mounted() {
    // console.log(this.$route.query.number)
    this.number = this.$route.query.number
    if(this.number){
      this.searchVisible = false
      this.getEvaluationReportDetail()
      this.detailsVisible = true
    }
    this.getContactInfo()
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    // 获取评级报告列表
    getEvaluationReportList() {
      this.loading = true
      evaluationReportList({
        number: this.number,
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.gridData = res.data.list
          this.records = res.data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取评价报告详情
    getEvaluationReportDetail() {
      evaluationReportDetail({
        number: this.number
      }).then(res => {
        if (res.code === 1) {
          this.info = res.data
        }
      })
    },
    // 获取联系信息
    getContactInfo() {
      contactInfoConfig().then(res => {
        if (res.code === 1) {
          this.phone = res.data.contact_info_hotline.value
          this.code = res.data.contact_info_official_account.value
        }
      })
    },
    handleSearch() {
      if (!this.keyword.trim()) {
        this.$message({
          message: '请输入搜索内容',
          type: 'warning'
        })
        return
      }
      if (this.$route.path === '/search') {
        this.$router.replace({ 
          path: '/search', 
          query: { 
            q: this.keyword,
          } 
        }).catch(() => { })
      } else {
        this.$router.push({ path: '/search', query: { q: this.keyword } }).catch(() => { })
      }
    },
     // 查询评价报告
    handleSearch2() {
      if (!this.number.trim()) {
        this.$message({
          message: '请输入报告编号',
          type: 'warning'
        })
        return
      }
      this.page = 1
      this.getEvaluationReportList()
    },
    handleClick(type) {
      if (type === 'about') {
        this.$router.push({ path: '/about' }).catch(() => { })
        this.currentNav = 'about'
      } else if (type === 'contact') {
        this.$router.push({ path: '/contact' }).catch(() => { })
      } else if (type === 'home') {
        this.$router.replace({ 
          path: '/', 
          query: { 
            timestamp: new Date().getTime()
          } 
        }).catch(() => { })
      }
    },
    handleNavClick(type) {
      this.currentNav = type
      this.$router.push({ path: `/${type}` }).catch(() => { })
    },
    // 查看详情
    handleDetailClick(row) {
      this.number = row.number
      this.getEvaluationReportDetail()
      this.searchVisible = false
      this.detailsVisible = true
    },
    // 更新当前导航
    updateCurrentNav() {
      const path = this.$route.path
      if (path === '/evaluation') {
        this.currentNav = 'evaluation'
      } else if (path === '/noveltySearch') {
        this.currentNav = 'noveltySearch'
      } else if (path === '/register') {
        this.currentNav = 'register'
      } else if (path === '/award') {
        this.currentNav = 'award'
      } else if (path === '/expert') {
        this.currentNav = 'expert'
      } else if (path === '/case'||path === '/caseDetails') {
        this.currentNav = 'case'
      } else if (path === '/about'||path === '/contact') {
        this.currentNav = 'about'
      }else{
        this.currentNav = ''

      }
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    // 移动端导航点击
    handleMobileNavClick(type) {
      this.handleNavClick(type)
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style scoped>
.header {
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 8px 0;
  font-size: 12px;
  background-image: url('../assets/image/headerbg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.main-nav {
  height: 500px;
  padding: 12px 0;
  background-image: url('../assets/image/headerbg2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

/* 主导航栏样式 */
.main-nav-bar {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  /* border-bottom: 1px solid #e0e0e0; */
}

.nav-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 15px;
  max-width: 1600px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 150px;
  height: 140px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 2px rgba(60,97,135,0.1);
  text-align: center;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.nav-item.active {
  background-color: #1B5AFF;
  color: white;
}

.nav-item img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.nav-item span {
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-item.active span {
  color: white;
}

.container {
  /* screen and (max-width: 1660px) */
  max-width: 1660px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-nav-right {
  display: flex;
  align-items: center;
  font-size: 16px;
  gap: 40px;
}

.search-box {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 6px 12px;
  height: 38px;
  border: none;
  border-radius: 4px;
  outline: none;
  font-size: 14px;
  width: 220px;
  margin-right: 10px;
}
.search-input2 {
  padding: 6px 12px;
  height: 38px;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  outline: none;
  font-size: 14px;
  width: 300px;
  margin-right: 10px;
}

.search-btn {
  padding: 6px 16px;
  height: 38px;
  background-color: #05004C;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.login-btn {
  margin-left: 30px;
  padding: 6px 16px;
  height: 38px;
  background: linear-gradient( 180deg, #FE9D00 0%, #E91D00 100%);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

/* 调整header的padding-top，避免内容被固定的top-nav遮挡 */
.header {
  padding-top: 74px;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
}

/* 移动端菜单 */
.mobile-menu {
  position: fixed;
  top: 74px;
  left: 0;
  right: 0;
  z-index: 998;
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.mobile-menu-content {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-nav-item:hover {
  background-color: #f5f5f5;
}

.mobile-nav-item.active {
  background-color: #1B5AFF;
  color: white;
}

.mobile-nav-item img {
  width: 30px;
  height: 30px;
  margin-right: 15px;
}

.mobile-nav-item i {
  font-size: 20px;
  margin-right: 15px;
}

.mobile-nav-item span {
  font-size: 16px;
  font-weight: 500;
}

.mobile-nav-item.active span {
  color: white;
}

/* 图片尺寸类 */
.logo {
  width: 308px;
  height: 58px;
}

.main-logo {
  width: 168px;
  height: 168px;
}

.main-title {
  width: 510px;
  height: 61px;
  margin-top: 16px;
}
 /* 对话框搜索表单样式 */
.search-form {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

/* 报告详情弹窗样式 */
.report-details {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 40px;
  /* flex-direction: column; */
}

.report-info {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  line-height: 1.5;
}

.info-label {
  font-size: 14px;
  white-space: nowrap;
  color: #333;
  margin-right: 10px;
  flex-shrink: 0;
}

.info-value {
  color: #333;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  word-break: break-word;
}

.report-certificate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-certificate img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  transform-origin: center;
  transition: transform 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .nav-items {
    gap: 10px;
  }
  
  .nav-item {
    padding: 15px 20px;
  }
  
  .nav-item img {
    width: 50px;
    height: 50px;
  }
  
  .nav-item span {
    font-size: 12px;
  }
  
  .logo {
    width: 250px;
    height: 46px;
  }
  
  .main-logo {
    width: 140px;
    height: 140px;
  }
  
  .main-title {
    width: 400px;
    height: 48px;
  }
}

@media (max-width: 992px) {
  .top-nav-right {
    gap: 20px;
  }
  
  .top-nav-right div {
    font-size: 12px;
  }
  
  .search-input {
    width: 180px;
  }
  
  .login-btn {
    margin-left: 20px;
  }
  
  .main-nav {
    height: 450px;
  }
}

@media (max-width: 768px) {
  .report-info {
    padding: 15px;
  }
  
  .info-row {
    margin-bottom: 12px;
  }
  
  .info-label {
    font-size: 10px;
    /* margin-right: 8px; */
  }
  
  .info-value {
    font-size: 10px;
  }
  
  .report-certificate img {
    max-height: 70vh;
    object-fit: contain;
  }
  .header {
    padding-top: 60px;
  }
  
  .top-nav {
    padding: 5px 0;
    height: 60px;
  }
  
  .top-nav-right {
    /* display: none; */
    font-size: 10px;
    /* gap: 10px; */
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .logo {
    width: 180px;
    height: 34px;
  }
  
  .main-nav {
    height: 350px;
    padding: 20px 0;
  }
  
  .main-logo {
    width: 100px;
    height: 100px;
  }
  
  .main-title {
    width: 280px;
    height: 34px;
    margin-top: 10px;
  }
  
  .search-box {
    flex-direction: column;
    gap: 10px;
    width: 90%;
    max-width: 300px;
  }
  
  .search-input {
    width: 100%;
    margin-right: 0;
  }
  
  .search-btn {
    width: 100%;
  }
  
  .login-btn {
    margin-left: 0;
    width: 100%;
  }
  
  /* .main-nav-bar {
    display: none;
  } */

  .nav-items {
    flex-wrap: wrap;
  }
  
  .mobile-menu {
    top: 60px;
  }
  
  .search-input2 {
    width: 200px;
  }
  
  .report-details {
    gap: 0px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }
  
  .logo {
    width: 150px;
    height: 28px;
  }
  
  .main-nav {
    height: 400px;
  }
  
  .main-logo {
    width: 80px;
    height: 80px;
  }
  
  .main-title {
    width: 220px;
    height: 27px;
  }
  
  .search-box {
    width: 95%;
  }
  
  .search-input2 {
    width: 150px;
  }
  
  .mobile-nav-item {
    padding: 12px 15px;
  }
  
  .mobile-nav-item img {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }
  
  .mobile-nav-item span {
    font-size: 14px;
  }
  .report-info {
    min-width: 100px;
  }
  .report-certificate {
    min-width: 100px;
  }
}
</style>